import { types, Instance } from 'mobx-state-tree';
const { model, string, identifierNumber, maybeNull, boolean } = types;

export const InviteModel = model('InviteModel', {
  id: identifierNumber,
  email: string,
  created_at: maybeNull(string),
  sent: boolean,
  updated_at: maybeNull(string),
  invite_type: string,
});

export type IInviteModel = Instance<typeof InviteModel>;

export const PasswordModel = model('PasswordModel', {
  id: identifierNumber,
  email: string,
  created_at: maybeNull(string),
  sent: boolean,
  updated_at: maybeNull(string),
  invite_type: string,
});

export type IPasswordModel = Instance<typeof PasswordModel>;
